var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "domNode",
      staticClass: "sc-emoji-picker",
      attrs: { tabIndex: "0" },
      on: { blur: _vm.onBlur },
    },
    [
      _c(
        "div",
        { staticClass: "sc-emoji-picker--content" },
        _vm._l(_vm.emojiData, function (category) {
          return _c(
            "div",
            { key: category.name, staticClass: "sc-emoji-picker--category" },
            [
              _c("div", { staticClass: "sc-emoji-picker--category-title" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(category.name) +
                    "\n            "
                ),
              ]),
              _vm._v(" "),
              _vm._l(category.emojis, function (emoji) {
                return _c(
                  "span",
                  {
                    key: emoji,
                    staticClass: "sc-emoji-picker--emoji",
                    on: {
                      click: function ($event) {
                        return _vm.emojiClicked(emoji)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                " + _vm._s(emoji) + "\n            "
                    ),
                  ]
                )
              }),
            ],
            2
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }